module.exports = __webpack_public_path__ + "static/img/pprocess3.757e09e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pprocess3.png
// module id = oSa4
// module chunks = 0